var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-chess-item-grades",style:(_vm.gradesStyle)},_vm._l((_vm.grades),function(grade){return _c('div',{key:grade.name,staticClass:"ui-chess-item-grades__item",style:(_vm.getGradeStyle(grade))})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }